import { ArrowDown, ArrowUp } from '@app/components/various/Icons';
import { Tables } from '@typings';
import cx from 'classnames';

interface Props {
  sortOrder?: Tables.SortOrder | null;
}

export const TableSorter = ({ sortOrder }: Props) => {
  const upArrowClasses = cx({
    'text-neutral-20': sortOrder === 'asc',
  });
  const downArrowClasses = cx({
    'text-neutral-20': sortOrder === 'desc',
  });

  return (
    <div className="flex flex-col gap-1.5 text-neutral-60">
      <span className={upArrowClasses}>
        <ArrowUp width={16} className="-m-2" />
      </span>
      <span className={downArrowClasses}>
        <ArrowDown width={16} className="-m-2" />
      </span>
    </div>
  );
};
